// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"cccccf97","963":"494906b5","992":"a7d3eaa7"}[chunkId] + ".css";
};